import HeroSection from "../components/HeroSection";
import LeadIn from "../components/LeadIn";
import HomeSouq from "../components/HomeSouq";
import HomeWatheeq from "../components/HomeWatheeq";
import HomePillars from "../components/HomePillars";
import VarietiesSection from "../components/VarietiesSection";
import CulinarySection from "../components/CulinarySection";
import StatsStrip from "../components/StatsStrip";
import StoriesTeaser from "../components/StoriesTeaser";
import PresentationButton from "../components/PresentationButton";
import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";
import { Tractor, Store, Gavel } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function LandingPage() {
  const { t } = useApp();
  return (
    <main data-testid="landing-page" className="home">
      <HeroSection />
      <LeadIn kicker={t("home.lead.souq.k")} title={t("home.lead.souq.t")} text={t("home.lead.souq.d")} testId="leadin-souq" />
      <HomeSouq />
      <LeadIn kicker={t("home.lead.wq.k")} title={t("home.lead.wq.t")} text={t("home.lead.wq.d")} testId="leadin-watheeq" />
      <HomeWatheeq />
      <LeadIn kicker={t("home.lead.pillars.k")} title={t("home.lead.pillars.t")} text={t("home.lead.pillars.d")} testId="leadin-pillars" />
      <HomePillars />
      <div className="lux-divider" aria-hidden="true" />
      <VarietiesSection />
      <div className="lux-divider" aria-hidden="true" />
      <CulinarySection />
      <div className="lux-divider" aria-hidden="true" />
      <StatsStrip />
      <div className="lux-divider" aria-hidden="true" />
      <StoriesTeaser />
      <Reveal>
        <section className="home-close" data-testid="home-close">
          <span className="section-tag">{t("home.close.k")}</span>
          <h2>{t("home.close.t")}</h2>
          <p>{t("home.close.d")}</p>
          <div className="home-cta-row">
            <Link to="/auth?type=farmer&mode=register" className="btn-lux-gold" data-testid="home-close-farmer"><Tractor size={16} /> {t("home.close.farmer")}</Link>
            <Link to="/auth?type=trader&mode=register" className="btn-lux-gold" data-testid="home-close-trader"><Store size={16} /> {t("home.close.trader")}</Link>
            <Link to="/auth?type=buyer&mode=register" className="btn-lux-ghost" data-testid="home-close-buyer"><Gavel size={16} /> {t("home.close.buyer")}</Link>
          </div>
        </section>
      </Reveal>
      <PresentationButton />
    </main>
  );
}
